import { PromoToggleKey } from '~/services/PromoService';

const ALLOW_PARENT_PROMO_CODE_USAGE_TOGGLE: PromoToggleKeyWithFallback = 'allow-parent-promo-code-usage';

export type PromoToggleKeyWithFallback = PromoToggleKey | (string & {});

export function hasAllowParentPromoCodeRequestsToggle(
  toggles: Array<PromoToggleKeyWithFallback> | null | undefined,
): boolean {
  return !!toggles?.includes(ALLOW_PARENT_PROMO_CODE_USAGE_TOGGLE);
}
